export default __webpack_public_path__ + "static/media/Darkclosebutton.b4eeaeca.svg";